import * as React from 'react';
import cs from 'classnames';
import PropTypes from 'prop-types';
import './index.external.css';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var canUseDOM = typeof document !== 'undefined';
var calculateHeaderOffsetValues = tr => {
  var offsetLeftValues;
  try {
    var trChildren = tr !== null && tr !== void 0 && tr.childNodes ? Array.from(tr.childNodes) : [];
    offsetLeftValues = trChildren.map(_ref => {
      var {
        offsetLeft = 0
      } = _ref;
      return offsetLeft;
    });
  } catch (e) {
    offsetLeftValues = [];
  }
  return offsetLeftValues;
};
var getWidth = () => {
  var width = 0;
  if (!canUseDOM) return width;
  try {
    width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  } catch (e) {
    width = 0;
  }
  return width;
};

var styles = {"tableContainer":"tableContainer-1r471","table":"table-1r471","tableHead":"tableHead-1r471","tableColHeader":"tableColHeader-1r471","tableColHeaderSticky":"tableColHeaderSticky-1r471","tableBody":"tableBody-1r471","tableRow":"tableRow-1r471","tableRowHeader":"tableRowHeader-1r471","tableCell":"tableCell-1r471"};

var _excluded$3 = ["classes", "columnHeading"];
var TableHead = _ref => {
  var {
      classes,
      columnHeading
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$3);
  var trRef = null;
  var [width, setWidth] = React.useState(getWidth());
  var [headingOffsetLeftValues, setHeadingOffsetLeftValues] = React.useState([]);
  React.useEffect(() => {
    setWidth(getWidth());
  }, []);
  React.useEffect(() => {
    setWidth(getWidth());
    setHeadingOffsetLeftValues([]);
    var handleResize = () => {
      setHeadingOffsetLeftValues([]);
      setWidth(getWidth());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setWidth, setHeadingOffsetLeftValues]);
  React.useEffect(() => {
    if (trRef !== null) {
      setHeadingOffsetLeftValues(calculateHeaderOffsetValues(trRef));
    }
  }, [width, setHeadingOffsetLeftValues, trRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, columnHeading.length > 0 && /*#__PURE__*/React.createElement("thead", _extends({
    className: cs(styles.tableHead, classes.tableHead)
  }, otherProps), /*#__PURE__*/React.createElement("tr", {
    className: styles.tableHeadRow,
    ref: el => trRef = el
  }, columnHeading.map((col, idx) => {
    var title = col !== null && col !== void 0 && col.value ? col.value : null;
    var {
      span = 1,
      isSticky = false
    } = col;
    var thStyles = isSticky && idx !== 0 && headingOffsetLeftValues[idx] !== undefined ? {
      left: "".concat(headingOffsetLeftValues[idx], "px")
    } : null;
    return /*#__PURE__*/React.createElement("th", {
      className: cs(styles.tableColHeader, classes.tableColHeader, {
        [styles.tableColHeaderSticky]: isSticky
      }),
      colSpan: span,
      key: "th-".concat(title, "-").concat(idx),
      scope: "col",
      style: thStyles
    }, title);
  }))));
};
var defaultProps$3 = {
  classes: {
    tableColHeader: '',
    tableHead: ''
  }
};
var propTypes$3 = {
  columnHeading: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    colSpan: PropTypes.number,
    isSticky: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })])).isRequired,
  classes: PropTypes.shape({
    tableColHeader: PropTypes.string,
    tableHead: PropTypes.string
  })
};
TableHead.defaultProps = defaultProps$3;
TableHead.propTypes = propTypes$3;

var _excluded$2 = ["cells", "classes"];
var TableRow = _ref => {
  var {
      cells,
      classes
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$2);
  if (!cells || !cells.length) return null;
  return /*#__PURE__*/React.createElement("tr", _extends({
    className: cs(styles.tableRow, classes.tableRow)
  }, otherProps), cells.map((cell, idx) => {
    var cellValue = cell !== null && cell !== void 0 && cell.value ? cell.value : null;
    var {
      isHeading = false,
      span = 1,
      value = ''
    } = cell;
    return isHeading ? /*#__PURE__*/React.createElement("th", {
      className: cs(styles.tableCell, styles.tableRowHeader, classes.tableCell, classes.tableRowHeader),
      key: "th-".concat(value, "-").concat(idx),
      rowSpan: span,
      scope: "row"
    }, cellValue) : /*#__PURE__*/React.createElement("td", {
      className: cs({
        [styles.tableCell]: !isHeading,
        [styles.tableRowHeader]: isHeading,
        [classes.tableCell]: !isHeading
      }),
      key: "th-".concat(value, "-").concat(idx)
    }, cellValue);
  }));
};
var defaultProps$2 = {
  classes: {
    tableCell: '',
    tableRow: '',
    tableRowHeader: ''
  }
};
var propTypes$2 = {
  cells: PropTypes.arrayOf(PropTypes.shape({
    isHeading: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })).isRequired,
  classes: PropTypes.shape({
    tableCell: PropTypes.string,
    tableRow: PropTypes.string,
    tableRowHeader: PropTypes.string
  })
};
TableRow.defaultProps = defaultProps$2;
TableRow.propTypes = propTypes$2;

var _excluded$1 = ["classes", "rows"];
var TableBody = _ref => {
  var {
      classes,
      rows
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  if (!rows || !rows.length) return null;
  var {
    tableBody,
    tableCell,
    tableRow,
    tableRowHeader
  } = classes;
  return /*#__PURE__*/React.createElement("tbody", _extends({
    className: cs(styles.tableBody, tableBody)
  }, otherProps), rows.map((row, idx) => /*#__PURE__*/React.createElement(TableRow, {
    cells: row,
    classes: {
      tableCell,
      tableRow,
      tableRowHeader
    }
    // eslint-disable-next-line react/no-array-index-key
    ,
    key: "table-row-".concat(idx)
  })));
};
var defaultProps$1 = {
  classes: {
    tableBody: '',
    tableCell: '',
    tableRow: '',
    tableRowHeader: ''
  }
};
var propTypes$1 = {
  classes: PropTypes.shape({
    tableBody: PropTypes.string,
    tableCell: PropTypes.string,
    tableRow: PropTypes.string,
    tableRowHeader: PropTypes.string
  }),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    isHeading: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }))).isRequired
};
TableBody.defaultProps = defaultProps$1;
TableBody.propTypes = propTypes$1;

var _excluded = ["caption", "classes", "columnHeading", "rows"];
var Table = _ref => {
  var {
      caption,
      classes,
      columnHeading,
      rows
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var {
    tableCaption,
    tableHead,
    tableBody,
    tableCell,
    tableColHeader,
    tableRowHeader
  } = classes;
  return /*#__PURE__*/React.createElement("div", {
    className: cs(styles.tableContainer, classes.tableContainer)
  }, /*#__PURE__*/React.createElement("table", _extends({
    className: cs(styles.table, classes.table)
  }, otherProps), caption && /*#__PURE__*/React.createElement("caption", {
    className: tableCaption
  }, caption), /*#__PURE__*/React.createElement(TableHead, {
    classes: {
      tableHead,
      tableColHeader
    },
    columnHeading: columnHeading
  }), /*#__PURE__*/React.createElement(TableBody, {
    classes: {
      tableBody,
      tableCell,
      tableRowHeader
    },
    rows: rows
  })));
};
var defaultProps = {
  caption: '',
  classes: {
    table: '',
    tableBody: '',
    tableCaption: '',
    tableCell: '',
    tableColHeader: '',
    tableContainer: '',
    tableHead: '',
    tableRow: '',
    tableRowHeader: ''
  }
};
var propTypes = {
  /** Text to be displayed as caption */
  caption: PropTypes.string,
  /**
    Data to be displayed as columns.
    The value can be either a string or node.
     columnHeading: PropTypes.arrayOf(
      PropTypes.shape({
        isSticky: PropTypes.bool,
        span: PropTypes.number,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      })
    ).isRequired,
  */
  columnHeading: PropTypes.arrayOf(PropTypes.shape({
    isSticky: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.node
  })).isRequired,
  /**
    Data to be displayed as rows.
    The value can be either a string or node.
    `isHeading` sets heading styles and can be omitted if using a rowspan.
    The headings are fixed.
     rows: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          isHeading: PropTypes.bool,
          span: PropTypes.number,
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        })
      )
    ).isRequired,
   */
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    isHeading: PropTypes.bool,
    span: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  }))).isRequired,
  /** Class Names to overwrite styling */
  classes: PropTypes.shape({
    table: PropTypes.string,
    tableBody: PropTypes.string,
    tableCaption: PropTypes.string,
    tableCell: PropTypes.string,
    tableColHeader: PropTypes.string,
    tableContainer: PropTypes.string,
    tableHead: PropTypes.string,
    tableRow: PropTypes.string,
    tableRowHeader: PropTypes.string
  })
};
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

export { Table, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
